<template>
  <router-link
    :to="to"
    class="dataset-info-box text-dark text-decoration-none"
    :class="{'dataset-info-box--catalog': catalogMode}"
  >
    <div class="d-flex justify-content-between w-100 mb-3 mb-sm-0">
      <div class="origin-badge">{{ origin }}</div>
      <div class="scope-badge">{{ scope }}</div> 
    </div>

    <div class="dataset-info-box-body">
      <div class="row">
        <div v-if="catalogMode && !compact" class="col-12 col-md-2">
          <img
            :src="src"
            alt="img"
            class="catalog-img border border-dark"
            :class="{'catalog-img--big': !compact}"
          />
        </div>

        <div
          class="dataset-info-box-description-container col-12 col-md"
          data-cy="dataset-description"
        >
          <slot name="header" v-if="compact">
            <div data-cy="dataset-title">
              <h2 class="card-title">{{ datasetOrCatalogTitle }}</h2>
            </div>
          </slot>

          <slot name="description">
            <pv-data-info-box-description
              v-if="!catalogMode || !compact"
              :class="'mb-3'"
              :description="dataset.description"
              :description-max-length="descriptionMaxLength"
              :truncate="descriptionMaxLength"
            />
          </slot>

          <slot name="after-description" />
        </div>
        <div
          v-if="scope === 'Dataset' || !catalogMode"
          class="dataset-info-box-badge-container col-12"
          :class="{ 'col-md-3': !compact }"
        >
          <div class="info-box-footer d-flex justify-content-between w-100 mb-3 mb-sm-0 mt-3 mb-sm-0">
            <div class="dataset-info-box-catalog d-flex align-items-center">
              <img
                class="dataset-info-box-footer-catalog-img border border-dark mr-3 ml-0"
                :src="src"
                :alt="catalogMode ? dataset.description : dataset.catalog">
              <span class="dataset-info-box-footer-catalog-description"> 
                {{ catalogMode ? dataset.description : dataset.catalog }}
              </span> 
            </div>
            <PvDataInfoBoxFormats :formats="dataset.formats" />
            
          </div>
        </div>
        <PvDataInfoBoxFooter
          v-if="catalogMode"
          class="col-12"
          :src="src"
          :createdDate="null"
          :updatedDate="null"
          :catalog="catalogMode ? dataset.description : dataset.catalog"
        />
        <!-- <div v-else class="dataset-info-box-footer" /> -->
      </div>
    </div>
  </router-link>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import type RouteLocationRaw from "vue-router";

import PvBadge from "./PvBadge.vue";
import PvDataInfoBoxDescription from "./PvDataInfoBoxDescription.vue";
import PvDataInfoBoxFooter from "./PvDataInfoBoxFooter.vue";
import PvDataInfoBoxFormats from "./PvDataInfoBoxFormats.vue"

export default defineComponent({
  name: "PvDataInfoBox",
  components: {
    PvBadge,
    PvDataInfoBoxDescription,
    PvDataInfoBoxFooter,
    PvDataInfoBoxFormats,
  },
  props: {
    scope: String,
    origin: String,
    /**
     * The dataset to display.
     */
    dataset: {
      type: Object,
      default: () =>
        ({
          title: "",
          description: "",
          catalog: "",
          createdDate: "12.12.2023",
          updatedDate: "13.12.2023",
          formats: [],
        }),
    },

    /**
     * The route to navigate to when clicking on the dataset.
     */
    to: {
      type: [Object, String] as PropType<RouteLocationRaw | string>,
      required: true,
    },

    /**
     * Specified the maximum length of the description before it is cut off.
     */
    descriptionMaxLength: {
      type: Number,
      default: 200,
    },

    /**
     * Image source for the catalog logo/flag.
     */
    src: {
      type: String,
      default: "",
    },

    /**
     * If true, swaps to catalog display mode
     */
    catalogMode: {
      type: Boolean,
      default: false,
    },

    /**
     * If true switches from two column to one column layout
     * and decreases vertical distancing between elements.
     */
    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    datasetOrCatalogTitle(): string {
      const { dataset, catalogMode } = this;
      return catalogMode
        ? dataset.title || dataset.catalog || ""
        : dataset.title || "";
    },
  },
});
</script>

<style lang="scss">
.scope-badge {
  border-radius: 4px;
  background-color: #eee;
  padding: 0 0.5rem;
  font-size: 14px;
}
.origin-badge {
  margin-left: 1.25rem;
  font-size: 14px;
}
.dataset-info-box-body {
  padding-top: 1rem;

}

.dataset-info-box {
  margin-bottom: 40px;
}

.dataset-info-box:hover {
  box-shadow: none !important;
  cursor: pointer;
}

.info-box-footer {

}
.dataset-info-box-catalog {
  flex-direction: row;
  img {
    margin-left: 1.5rem;
    margin-right: 0;
  }
}

@media screen and (max-width: 768px) {
  .origin-badge {
    margin-left: 0px;
    font-size: 14px;
  }
  
}

</style>
